// todo: check if we need to remove it for production
import 'expo-dev-client';

import React, {useLayoutEffect, useEffect} from 'react';

import * as Notifications from 'expo-notifications';
import {I18nManager, Platform} from 'react-native';
import {QueryClient, QueryClientProvider} from 'react-query';

import {AuthProvider} from '@medad-sep/core';

// todo: remove later dummy comment
// todo : remove when this is released https://github.com/software-mansion/react-native-gesture-handler/pull/2404
import 'setimmediate';

import './src/localization';

import playgroundConfig from './applet-playground';
import {config} from './config/env';
import AppletPlayground from './src/Playground';
import {AppVersion} from './src/shared/AppVersion';
import ShellContainer from './src/ShellContainer';
import {requestAndroidNotificationsPermissions} from './utils/requestAndroidNotificationsPermissions';
import {requestIOSNotificationsPermission} from './utils/requestIOSNotificationsPermission';

const queryClient = new QueryClient({
  defaultOptions: {queries: {refetchOnWindowFocus: false, retry: 0}},
});

const Content = playgroundConfig.applet ? AppletPlayground : ShellContainer;

Notifications.setNotificationHandler({
  handleNotification: async () => ({
    shouldShowBanner: true,
    shouldShowList: true,
    shouldPlaySound: false,
    shouldSetBadge: false,
  }),
});

function App() {
  useEffect(() => {
    if (Platform.OS === 'web') return;
    const requestPermissions = async () => {
      await requestAndroidNotificationsPermissions();
      await requestIOSNotificationsPermission();
    };
    requestPermissions();
  }, []);

  useLayoutEffect(() => {
    if (I18nManager.isRTL) {
      I18nManager.allowRTL(false);
      I18nManager.forceRTL(false);
    }
  }, [I18nManager]);
  return (
    <AuthProvider config={config.ssoConfigs}>
      <QueryClientProvider client={queryClient}>
        <Content />
      </QueryClientProvider>

      <AppVersion />
    </AuthProvider>
  );
}

export default App;
